import { render, staticRenderFns } from "./AgreementCheckBox.vue?vue&type=template&id=21d5773a"
import script from "./AgreementCheckBox.vue?vue&type=script&lang=js"
export * from "./AgreementCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports